export default {
  distanceToCampus: 'Distance to Campus',
  invitationLastSentOn: 'Invitation Last Sent On',
  walletBalance: 'Wallet Balance',
  flexiShuttleUsers: 'flexiShuttle Users',
  flexiShuttleFlexiVanpoolUsers: 'flexiShuttle/flexiVanpool  Users',
  flexiCarUsers: 'flexiCar Users',
  mobilityChallenged: 'Assistance Required',
  emailNoSpaces: 'Email cannot contain spaces',
  userAgreementDate: 'User Agreement Date',
  pregnant: 'Pregnant',
  registrationDate: 'Registration Date',
  shift: 'Shift',
  eligibleFor: 'Eligible For',
  drivingLicence: 'Driving Licence',
  currentModeCommute: 'Current Mode of Commute',
  walkingDistance: 'Walking Distance',
  travelDistance: 'Travel Distance*',
  travelTime: 'Travel Time*',
  totalEmission: 'Total Emission*',
  line: 'Line',
  basicInfo: 'Basic Info',
  workSystemInfo: 'Work & System Info',
  commuteInfo: 'Commute Info',
  supportRequests: 'Support Requests',
  cardReads: 'Card Reads',
  badgeScans: 'Badge Scans',
  showCardReads: 'Show Card Reads',
  addLevel: 'Add Level',
  level: 'Level',
  pleaseEnterEmail: 'Please enter email',
  received: 'Received',
  solved: 'Solved',
  assignAdmin: 'Assign Admin',
  personnelDeleted: 'Rider Deleted',
  welcomeEmail: 'Welcome Email',
  welcomeEmailWillBeSent: '{1} will be sent to {0} user(s). Do you confirm?',
  welcomeEmailWillBeSentNamed: '{1} will be sent to {0}. Do you confirm?',
  welcomeEmailSent: 'Welcome Email Sent',
  usingService: 'User Status',
  suspendForNearDemand: 'Suspend for Near Demand',
  suspensionFrom: 'From',
  suspensionUntil: 'Until',
  suspensionReasonLabel: 'Suspend Reason',
  suspendedUntil: 'Suspend Until',
  suspendedBy: 'Suspended By',
  suspendedBySystem: 'System',
  suspensionReason: {
    cancellation: 'Late Cancellations',
    noShow: 'No-show',
    other: 'Other',
  },
  noSupportRequests: 'No support requests received.',
  createdPersonnel: 'Personnel has been created',
  updatedPersonnel: 'Personnel has been updated',
  addEmployee: 'Add Rider',
  downloadExcel: 'Please download the template, fill it with your employee data and upload it here.',
  confirmDeletePersonnel: 'You are about to remove {0}. This action cannot be undone. Do you want to continue?',
  confirmDeletePersonnels:
    'You are about to remove {0} personnel. This action cannot be undone. Do you want to continue?',
  passwordValidationInfo:
    'The password must be at least 8 characters long and must contain at least three of the following: one uppercase letter, one lowercase letter, one number, and one special character ({symbols}).',
  userDeleted: 'The user was deleted !',
  flexiRideUsers: 'flexiRide Users',
  assistantAssigned: 'Assistant has been assigned',
  assignAssistantToSelected: 'Assign Assistant to Selected',
  selectAssistant: 'Select Assistant',
  assistantRole: 'Assistant Role',
  ridersAssistant: 'Riders Assisted',
  assistedby: 'Assisted By',
  assistantAdminEmail: 'Assistant Admin Email',
  cantAssignThisUser: 'You can not assign this user as assistant to the selected user',
  assistant: 'Assistant',
  assistants: 'Assistants',
  addNewRider: 'Add New Rider',
  addNewAssistant: 'Add New Assistant',
  ridersAssistedBy: 'Riders Assisted by {0}',
  assistantsTo: 'Assistants to',
  searchPersonnel: 'Search Personnel',
  requiredNoteToEnterNote: 'Please note if the user has specific preferences about the mobility services.',
  issueDate: 'Issue Date',
  validThrough: 'Valid Through',
  closePanel: 'Are you sure you want to close the panel? Any unsaved changes will be lost',
  flexiRideAssistant: 'flexiRide Assistant',
  assitanceDuePermanently: 'Permanently',
  assistanceDueUntil: 'Until',
  assistanceCategories: 'Assistance Categories',
  assistanceCategory: {
    WHEELCHAIR: 'Wheelchair',
    CRUTCHES: 'Crutches',
    VISUAL_IMPAIREMENT: 'Visual Impairment',
    HEARING: 'Hearing',
  },
  affiliateCompany: 'Affiliate Company',
  shiftType: {
    label: 'Work Schedule',
    regular: 'Regular',
    variable: 'Variable',
  },
  shuttleShifts: {
    label: 'Shuttle Shifts',
    placeholder: 'Select the shift(s) the rider may be assigned to.',
    tooltip:
      'If your company shuttles operate on a reservation basis, you can leave this field empty. Add route groups if you want the rider to be automatically assigned to a route and stop suggested by the system when they are added to those groups.',
  },
  onDemandPrivateDetails: 'On-Demand Private Details',
  onDemandPrivateAssistant: 'On-Demand Private Assistant',
  addressUpdated:
    "The rider's address has been updated. Please review the system's updated route suggestions and complete any required assignments.",
  viewRoutes: 'View Routes',
  shuttleShiftsAdded:
    'For newly added users with a defined route group, the system will associate the most suitable route and stop. This process may take a few minutes. You can view the suggested routes later in the Associations tab under the flexiShuttle Shuttle Users screen.',
  insufficientPrivileges: "You don't have permission to view this rider's details.",
  addGuaranteedRide: 'Add Guaranteed Ride',
  numberOfGuaranteedRides: 'Number of GRs to add',
  guaranteedRideRange: 'Please enter a value between {0} and {1}',
  addGuaranteedRideConfirm: 'Do you want to add {0} guaranteed rides to the selected rider(s)?',
  addGuaranteedRideSuccess: '{0} ride(s) added successfully',
  guaranteedRidesLeft: 'Guaranteed Rides Left',
  guaranteedRideQuotaWarning:
    'Riders can have a maximum of {0} guaranteed rides. New rides will top up their current balance up to this limit.',
  someEmployeesNotEligibleForGuaranteedRide:
    'Some selected employees are not eligible for Guaranteed Ride Home. They will be skipped.',
};
